"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class File extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'file';
        this._itemType = initParams.item_type;
        this._itemId = initParams.item_id;
        this._name = initParams.name;
        this._type = initParams.type;
        this._size = initParams.size;
        this._file = initParams.file;
        this._ref = initParams.ref;
        this._description = initParams.description;
        this._location = initParams.location;
        this._thumbnail = initParams.thumbnail;
        this._uploadRef = initParams.upload_ref;
        this._uploadedByName = initParams.uploaded_by_name;
        this._ORN = initParams.o_r_n;
        this._uploadedStamp = initParams.uploaded_stamp;
    }
    set itemType(value) {
        console.error('Do not set objects this way');
    }
    setItemType(value) {
        return this.dataService.updateFile(this.id, { item_type: value }, this);
    }
    get itemType() {
        return this._itemType;
    }
    set itemId(value) {
        console.error('Do not set objects this way');
    }
    setItemId(value) {
        return this.dataService.updateFile(this.id, { item_id: value }, this);
    }
    get itemId() {
        return this._itemId;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateFile(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set type(value) {
        console.error('Do not set objects this way');
    }
    setType(value) {
        return this.dataService.updateFile(this.id, { type: value }, this);
    }
    get type() {
        return this._type;
    }
    set size(value) {
        console.error('Do not set objects this way');
    }
    setSize(value) {
        return this.dataService.updateFile(this.id, { size: value }, this);
    }
    get size() {
        return this._size;
    }
    set file(value) {
        console.error('Do not set objects this way');
    }
    setFile(value) {
        return this.dataService.updateFile(this.id, { file: value }, this);
    }
    get file() {
        return this._file;
    }
    set ref(value) {
        console.error('Do not set objects this way');
    }
    setRef(value) {
        return this.dataService.updateFile(this.id, { ref: value }, this);
    }
    get ref() {
        return this._ref;
    }
    set description(value) {
        console.error('Do not set objects this way');
    }
    setDescription(value) {
        return this.dataService.updateFile(this.id, { description: value }, this);
    }
    get description() {
        return this._description;
    }
    set location(value) {
        console.error('Do not set objects this way');
    }
    setLocation(value) {
        return this.dataService.updateFile(this.id, { location: value }, this);
    }
    get location() {
        return this._location;
    }
    set thumbnail(value) {
        console.error('Do not set objects this way');
    }
    setThumbnail(value) {
        return this.dataService.updateFile(this.id, { thumbnail: value }, this);
    }
    get thumbnail() {
        return this._thumbnail;
    }
    set uploadRef(value) {
        console.error('Do not set objects this way');
    }
    setUploadRef(value) {
        return this.dataService.updateFile(this.id, { upload_ref: value }, this);
    }
    get uploadRef() {
        return this._uploadRef;
    }
    set uploadedByName(value) {
        console.error('Do not set objects this way');
    }
    setUploadedByName(value) {
        return this.dataService.updateFile(this.id, { uploaded_by_name: value }, this);
    }
    get uploadedByName() {
        return this._uploadedByName;
    }
    set ORN(value) {
        console.error('Do not set objects this way');
    }
    setORN(value) {
        return this.dataService.updateFile(this.id, { o_r_n: value }, this);
    }
    get ORN() {
        return this._ORN;
    }
    set uploadedStamp(value) {
        console.error('Do not set objects this way');
    }
    setUploadedStamp(value) {
        return this.dataService.updateFile(this.id, { uploaded_stamp: value }, this);
    }
    get uploadedStamp() {
        return this._uploadedStamp;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateFile(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteFile(this.id, this);
    }
}
exports.default = File;
//# sourceMappingURL=file.js.map